import { Button } from '@/shared/ui/Button'

// Segmented control leve (2+ abas) reusando o estilo de chips da loja:
// aba ativa `primary`, inativa `primary-ghost`.
export const DigitalProductStoreWithdrawBottomSheetTabs = ({
  value,
  onChange,
  tabs
}) => (
  <div className="mb-4 grid grid-cols-2 gap-2">
    {tabs.map((tab) => (
      <Button
        key={tab.value}
        type="button"
        size="sm"
        variant={value === tab.value ? 'primary' : 'primary-ghost'}
        showTrailingIcon={false}
        className="w-full !rounded-2xl"
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
      </Button>
    ))}
  </div>
)
